/**
 * Project dashboard
 *
 * Created by stefensuhat on 14/08/18 9.43 AM
 */

import { api } from 'utils';

const defaultState = {
    items: [],
    meta: {
        total: 1,
        per_page: 15,
        current_page: 1,
    },
    errors: null,
};

export default {
    name: 'admin',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
    },
    effects: {
        async fetch(params) {
            await api.get('admins', { params })
                .then((response) => this.fetchResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.admin, (admin) => admin.items);
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (admins, selectedId) => {
                    if (selectedId === 'create') {
                        return false;
                    }

                    return admins.find((admin) => admin.id === selectedId);
                },
            );
        },
    }),
};
